import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useNetwork, useNetworkByName, useNetworkByCode, useNetworkBySubdomain } from '../hooks/useNetworks';
import { NetworkDetailTabs } from '../components/network/NetworkDetailTabs';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { getNetworkImageUrl } from '../utils/helpers';
import appConfig from '../utils/appConfig';
import { FaArrowLeft } from 'react-icons/fa';

export const NetworkDetailPage = () => {
  const { id, name, code, networkCode } = useParams();
  const navigate = useNavigate();
  const isSingleNetworkMode = appConfig.isSingleNetworkMode();

  // Debug: Log the parameters to verify they're being received
  console.log('Route params:', { id, name, code, networkCode });

  // Determine which parameter to use
  const isUsingNetworkCode = !!networkCode;
  const isUsingCode = !!code && !networkCode;
  const isUsingName = !!name && !code && !networkCode;
  const isUsingId = !!id && !name && !code && !networkCode;

  // Only call the hook that's actually needed
  const networkByName = useNetworkByName(isUsingName ? name : null);
  const networkByCode = useNetworkByCode(isUsingCode ? code : null);
  const networkBySubdomain = useNetworkBySubdomain(isUsingNetworkCode ? networkCode : null);
  const networkById = useNetwork(isUsingId ? id : null);

  // Select the appropriate result
  const { network, loading, error } = isUsingNetworkCode ? networkBySubdomain : (isUsingCode ? networkByCode : (isUsingName ? networkByName : networkById));

  if (loading) return <LoadingSpinner />;
  if (error || !network) return <div className="alert alert-danger">Network not found</div>;

  const imageUrl = getNetworkImageUrl(network);

  return (
    <div className="fade-in">
      {!isSingleNetworkMode && (
        <button className="btn btn-outline-secondary mb-3" onClick={() => navigate('/')}>
          <FaArrowLeft style={{ marginRight: '8px' }} /> Back to Networks
        </button>
      )}
      <h2 className="mb-4">{network.name}</h2>
      <NetworkDetailTabs network={network} />
    </div>
  );
};
